import React from 'react'
import Header from '../../../Components/Header'

function RollOffs({ heading_size = 2 }) {
    return (
        <>
            <Header text={"Roll Offs"} level={heading_size}/>
            <div>
                Data
            </div>
        </>
    )
}

export default RollOffs